import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { useContext } from 'react';
import classnames from 'classnames';
import { ContainerContext } from "../../../context/container.context";
import styles from "./Container.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var Container = function Container(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$innerClassName = _ref.innerClassName,
    innerClassName = _ref$innerClassName === void 0 ? '' : _ref$innerClassName,
    _ref$inlineStyle = _ref.inlineStyle,
    inlineStyle = _ref$inlineStyle === void 0 ? {} : _ref$inlineStyle,
    _ref$innerInlineStyle = _ref.innerInlineStyle,
    innerInlineStyle = _ref$innerInlineStyle === void 0 ? {} : _ref$innerInlineStyle;
  var context = useContext(ContainerContext);
  var containerAlign = context.containerAlign,
    containerMaxWidth = context.containerMaxWidth;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.containerFluid, {
      [styles["container".concat(_capitalize(containerAlign))]]: containerAlign
    }, className),
    "data-e2e-name": "container",
    style: inlineStyle,
    children: /*#__PURE__*/_jsx("div", {
      className: classnames(styles['containerFluidInner'], innerClassName),
      style: _objectSpread(_objectSpread({}, innerInlineStyle), {}, {
        maxWidth: containerMaxWidth || undefined
      }),
      children: children
    })
  });
};